import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { ArticleTag, NewsItem } from './newsApi'
import { getLang } from '@/helpers/getLang'

interface AddArticleDto {
    title: string
    description: string
    responsible_id: number[]
    card_id: number[]
    photos: string[]
    videos: string
    tags_id: number[]
    preview: string
    intro: number
    products_id: number[]
    type?: 'article' | 'usefulMaterials'
    subtitle: string
}

export type MaterialsItem = {
    id: number
    title: string
    description: string
    views: number
    creation_date: string
    responsible_id: {
        id: number
        name: string
        position: number
        photo: string
    }[]
    card_id: number[]
    photos: string[]
    videos: string
    tags_id: ArticleTag[]
    preview: string
    intro: string
    products_id: number[]
    type: string
    subtitle: string
    date: string
    image_url: string
    likes: string
    megamix: string
    saves: string
    specialization: string
}

export type MaterialsFilterType = {
    get: number,
    page: number,
    tags: number[],
    title: string
}

export const materialsApi = createApi({
    reducerPath: 'materialsApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.NEXT_PUBLIC_API_ENDPOINT || 'http://megakorm.ru:3005/api'
    }),
    endpoints: builder => ({
        getMaterial: builder.query<MaterialsItem, { id: number }>({
            query: ({ id }) => ({ url: `/articles/useful-materials/${id}` })
        }),
        getAllMaterials: builder.query<MaterialsItem[], { count: number; page: number }>({
            query: ({ count, page }) => ({ url: `/articles/useful-materials/pages?get=${count}&page=${page}&lang=${getLang()}` }),
        }),
        getMaterialsCategories: builder.query<MaterialsItem[], void>({
            query: () => ({ url: `/useful-materials-types?lang=${getLang()}` }),
        }),
        filterMaterials: builder.mutation<MaterialsFilterType, any>({
            query: (body) => ({ url: `/articles/useful-materials/pages/filter/count?lang=${getLang()}`, method: "POST", body: body })
        }),
        createMaterial: builder.mutation<any, AddArticleDto>({
            query: data => ({ url: `/articles/useful-materials`, method: 'POST', body: data })
        })
    })
})

export const { useGetMaterialQuery, useGetAllMaterialsQuery, useFilterMaterialsMutation, useGetMaterialsCategoriesQuery, useCreateMaterialMutation } = materialsApi
